// Copyright 2024 Sorama B.V.
import { PLATFORM } from "aurelia-framework";
import { CAMiV64GuidanceCatalog } from "catalogs/GuidanceCatalog/CAMiV64GuidanceCatalog";
import { TimelineEntryType } from "datatypes/SoramaWebApi";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModes } from "services/WorkflowModes/WorkflowModes";
import { MeasuringGuidanceCatalog } from "./../GuidanceCatalog/MeasuringGuidanceCatalog";

export class MeasurementWorkflowModuleCatalog {
    static hardwareSelectionModule: IWorkflowModuleConfig = {
        name: "hardwareselection",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/HardwareSelection/HardwareSelectionModule"),
        title: "Hardware Selection",
        moduleType: WorkflowModuleType.Measurement,
        requireClient: true,
        requireSignIn: false,
    };

    static MeasureModule: IWorkflowModuleConfig = {
        name: "measure",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/Measure/MeasureModule"),
        title: "Measure Module",
        moduleType: WorkflowModuleType.Measurement,
        requireClient: true,
        requireSignIn: false,
        timelineEventType: TimelineEntryType.Measurement,
    };

    static MeasurementPreparationModule: IWorkflowModuleConfig = {
        name: "measurementpreparation",
        modulePath: PLATFORM.moduleName(
            "modules/workflows/Measurement/MeasurementPreparation/MeasurementPreparationModule"
        ),
        title: "Measurement Preparation",
        moduleType: WorkflowModuleType.Measurement,
        requireClient: true,
        help: MeasuringGuidanceCatalog.MeasuringOverviewModule,
        requireSignIn: false,
        isInadmissible: true,
    };

    static VideoModule: IWorkflowModuleConfig = {
        name: "video",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/Video/VideoModule"),
        title: "Video",
        moduleType: WorkflowModuleType.Measurement,
        requireClient: true,
        canExtend: true,
        requireSignIn: false,
    };

    static MeasurementModule: IWorkflowModuleConfig = {
        name: "measurement",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/Measurement/MeasurementModule"),
        title: "Measurement Info",
        moduleType: WorkflowModuleType.Measurement,
        requireSignIn: false,
        requireClient: false,
    };

    static RecordingMetadataModule: IWorkflowModuleConfig = {
        name: "measurementdetails",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/RecordingMetadata/RecordingMetadataModule"),
        title: "Recording Metadata",
        moduleType: WorkflowModuleType.Measurement,
        isInadmissible: true,
        requireSignIn: false,
        requireClient: true,
    };

    static MeasurementsListModule: IWorkflowModuleConfig = {
        name: "measurements",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/MeasurementsList/MeasurementsListModule"),
        title: "Measurements",
        moduleType: WorkflowModuleType.Measurement,
        isInadmissible: true,
        requireSignIn: false,
        requireClient: false,
        canExtend: true,
    };

    static TimelineModule: IWorkflowModuleConfig = {
        name: "timeline",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/Timeline/TimelineModule"),
        title: "Timeline",
        moduleType: WorkflowModuleType.Measurement,
        isInadmissible: false,
        requireSignIn: false,
        requireClient: true,
    };

    static MeasurementAreaModule: IWorkflowModuleConfig = {
        name: "measurementarea",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/MeasurementArea/MeasurementAreaModule"),
        title: "Measurement Area",
        moduleType: WorkflowModuleType.Measurement,
        requireSignIn: false,
        requireClient: true,
    };

    static ProjectManagementModule: IWorkflowModuleConfig = {
        name: "project_management",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/ProjectManagement/ProjectManagementModule"),
        title: "Project Management",
        isInadmissible: true,
        moduleType: WorkflowModuleType.Measurement,
        requireSignIn: true,
    };

    static ManageCamIV64FileModule: IWorkflowModuleConfig = {
        name: "manage_cam_iv64_files",
        modulePath: PLATFORM.moduleName("modules/workflows/Measurement/ManageCamIV64File/ManageCamIV64FileModule"),
        title: "Manage CAM iV64 files",
        moduleType: WorkflowModuleType.Measurement,
        isInadmissible: true,
        requireSignIn: true,
        requireClient: true,
        disableForWorkflowModes: [
            WorkflowModes.AcousticDesignCycle,
            WorkflowModes.IndustrialFixed,
            WorkflowModes.IndustrialHandheld,
        ],
        help: CAMiV64GuidanceCatalog.CAMiV64_DownloadReport,
    };
}
